import type { ProjectRecord, ProjectState } from "@/api/projects/useProjects"
import type { Task } from "@/api/tasks/useTasksSearch"
import type { Milestone } from "@/api/milestones/useMilestones"

export type { ProjectRecord, ProjectState, Task, Milestone }

export type WorkflowStatus =
  | "waiting"
  | "in_progress"
  | "review"
  | "completed"
  | "cancelled"

export type ProjectRailTab = "fields" | "status" | "activity"
export type ProjectMainTab = "overview" | "tasks" | "timeline" | "dashboard" | "files" | "activity"

export type MilestoneDraft = {
  title: string
  plannedEnd: string
  assigneeId: string
}

export type ActivityCategory = "project" | "task" | "comment" | "person" | "other"
export type ActivityFilterCategory = "all" | "project" | "task" | "comment" | "person"

export type ActivityItem = {
  id: number
  occurredAt: string
  actor: { id: string | null; name: string; avatarUrl?: string }
  category: ActivityCategory
  title: string
  details?: string
}

export const PROJECT_RAIL_WIDTH_CLASS_NAME = "w-96"

export const STATE_OPTIONS: Array<{
  value: ProjectState
  label: string
  color: string
}> = [
  { value: "on_track", label: "По плану", color: "bg-emerald-500" },
  { value: "at_risk", label: "Риск", color: "bg-amber-500" },
  { value: "delayed", label: "Задержка", color: "bg-rose-500" },
  { value: "on_hold", label: "На паузе", color: "bg-slate-400" },
  { value: "completed", label: "Завершён", color: "bg-sky-500" },
]

export const WORKFLOW_OPTIONS: Array<{ id: WorkflowStatus; label: string }> = [
  { id: "waiting", label: "Ожидает" },
  { id: "in_progress", label: "В работе" },
  { id: "review", label: "Проверка" },
  { id: "completed", label: "Завершён" },
  { id: "cancelled", label: "Отменён" },
]

export const ACTIVITY_FILTER_LABELS: Record<ActivityFilterCategory, string> = {
  all: "Все",
  project: "Проект",
  task: "Задачи",
  comment: "Комментарии",
  person: "Участники",
}

export const PROJECT_FIELD_LABELS: Record<string, string> = {
  name: "название",
  description: "описание",
  status: "статус",
  state: "состояние",
  owner: "руководителя",
  start_date: "дату начала",
  end_date: "дату окончания",
  progress: "прогресс",
}

export const TASK_FIELD_LABELS: Record<string, string> = {
  title: "название",
  description: "описание",
  assignee_id: "исполнителя",
  priority: "приоритет",
  project_id: "проект",
  parent_task_id: "родительскую задачу",
  planned_start: "дату начала",
  planned_end: "дату окончания",
  estimated_hours: "оценку",
  is_milestone: "признак вехи",
}

export const STATE_LABELS: Record<string, string> = {
  on_track: "По плану",
  at_risk: "Риск",
  delayed: "Задержка",
  on_hold: "На паузе",
  completed: "Завершён",
}
